import { render } from "./AddInformationWithEntity.vue?vue&type=template&id=123d249c&scoped=true&ts=true"
import script from "./AddInformationWithEntity.vue?vue&type=script&lang=ts"
export * from "./AddInformationWithEntity.vue?vue&type=script&lang=ts"

import "./AddInformationWithEntity.vue?vue&type=style&index=0&id=123d249c&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123d249c"]])

export default __exports__